import { useEffect, useState } from 'react';

import { Icone } from '../componentes/Icone';
import { ponteDesktop } from './ponte';

export const ALTURA_BARRA = 32;

/**
 * Barra de título do app para computador (E2): arrasta a janela. Os botões
 * de minimizar, maximizar e fechar são os do sistema, por cima dela (no
 * Windows e no Linux à direita, no macOS os semáforos à esquerda).
 */
export function BarraDeTitulo() {
  const ponte = ponteDesktop();
  const [telaCheia, setTelaCheia] = useState(false);
  useEffect(() => {
    if (!ponte) return;
    void ponte.janela.estado().then((estado) => {
      if (estado) setTelaCheia(estado.telaCheia);
    });
    return ponte.janela.aoMudar((estado) => setTelaCheia(estado.telaCheia));
  }, [ponte]);
  if (!ponte || telaCheia) return null;
  const mac = ponte.plataforma === 'darwin';
  return (
    <div
      role="toolbar"
      aria-label="Barra de título"
      onDoubleClick={() => ponte.janela.maximizar()}
      className="flex shrink-0 items-center bg-rail select-none"
      style={
        {
          height: ALTURA_BARRA,
          paddingLeft: mac ? 80 : 12,
          // Os botões do sistema ocupam a direita no Windows e no Linux.
          paddingRight: mac ? 12 : 140,
          WebkitAppRegion: 'drag',
        } as React.CSSProperties
      }
    >
      <span className="flex items-center gap-2">
        <span
          aria-hidden="true"
          className="flex size-4 items-center justify-center rounded bg-destaque text-destaque-texto"
        >
          <Icone nome="logo" tamanho={12} />
        </span>
        <span className="text-xs font-semibold text-texto-3">
          Alternativa Chat
        </span>
      </span>
    </div>
  );
}
